import gql from 'graphql-tag';
// import { disclosureFragment } from '../../graphql/queries/selective-disclosure.query';

export const TOP_TEN_ISSUERS = gql`
    query TopTenIssuers($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            inceptionDate
            broadAssetClass
            selectiveDisclosures {
                quarterly {
                    ...Disclosure
                }
                monthly {
                    ...Disclosure
                }
            }
        }
    }

    fragment Disclosure on SelectiveDisclosure {
        asOfDate
        totalHoldings
        top10CalculatedPercentage
        individualHoldings {
            name
            rank
            percentTotalNetAssets
            issuerGuarantorTypeName
        }
    }

`;
